/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import * as user_common from './user_common';

export type Int64 = string | number;

export interface BuiAuditInfo {
  AuditStatus?: user_common.PassportAuditStatus;
  UnPassReason?: string;
  LastModifyTime?: Int64;
  /** map[string]AuditInfo 的序列化字段，下面的注释是具体的struct结构 */
  AuditInfoJson?: string;
}
/* eslint-enable */
